import { useState } from 'react'

const useSpyMode = () => {
  const [isSpyMode, setIsSpyMode] = useState(
    window.localStorage.getItem('spyMode') === 'true'
  )

  const updateSpyMode = (value: boolean) => {
    window.localStorage.setItem('spyMode', value.toString())
    setIsSpyMode(value)
  }

  return {
    isSpyMode,
    updateSpyMode,
  }
}

export default useSpyMode
